import React from "react";
import "./Status.scss";

const Status = () => {
  return (
    <div className="status">
      <div className="con">
        <div className="status__numbers">
          <h1>85+ </h1>
          <p>Teachers</p>
        </div>
        <div className="status__numbers">
          <h1>850+ </h1>
          <p>Students</p>
        </div>
        <div className="status__numbers">
          <h1>55+ </h1>
          <p>Courses</p>
        </div>{" "}
        <div className="status__numbers">
          <h1>25+ </h1>
          <p>Country</p>
        </div>
      </div>
    </div>
  );
};

export default Status;
